import React, { useState } from "react";
import "./PapayaThemePageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import LeftDrawer from "./components/LeftDrawer/LeftDrawer";
import ComingSoonModal from "./components/ComingSoonModal/ComingSoonModal";
import { useSelector } from "react-redux";
const PapayaThemePageWrapper = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const iscoming = useSelector((state) => state.companyData.isComing)

    return (
        <div className="PapayaThemePageWrapper">
            <LeftDrawer
                isOpen={isMenuOpen}
                setIsOpen={setIsMenuOpen} />
            <Navbar
                setIsMenuOpen={setIsMenuOpen} />
            {children}
            {iscoming && <ComingSoonModal />}
            <Footer />
        </div>
    )
}
export default PapayaThemePageWrapper